/**
 * PlayerCardContent — the player card's face.
 * @module components/organisms/custom/ui/PlayerCardContent
 */

export { default } from "./PlayerCardContentView";
export type { PlayerCardContentViewProps } from "./PlayerCardContentView";
